/**
 * Created by dmitry on 27.01.2026
 */

// defaults for every reward type, including the ones registered later
RewardType.prototype.getStartReceiveRewardEffect = function () {
    return "ui.receive";
};

RewardType.prototype.getCollectRewardEffect = function () {
    return "ui.reward.accrual";
};

RewardTypes.hard.getStartReceiveRewardEffect = function () {
    return "ui.receive.hard";
};

RewardTypes.soft.getStartReceiveRewardEffect = function () {
    return "ui.receive.soft";
};

Reward.register("mistakes", {
    countable: true,
    getIcon: function () {
        return bundles.reward_icons.frames.mistakes_icon_png;
    },

    receive: function () {
        return function () {};
    }
});
